import { createFileRoute } from "@tanstack/react-router";
import { KostenPage, kostenHead } from "../components/KostenPage";
import { kostenGuides } from "../lib/kosten-guides";

export const Route = createFileRoute("/dakkapel-kosten")({
  head: () => kostenHead(kostenGuides.dakkapel),
  component: () => <KostenPage guide={kostenGuides.dakkapel} />,
});
